<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';

  .sidebar {
    padding: 20px 30px;
  }
  a {
    color: hsl(0, 0%, 30%);
    padding-top: 15px;
  }
  .icon {
    padding-right: 15px;
  }
  /deep/ .router-link-exact-active {
    color: $primary;
  }
</style>


<template>
  <div class="sidebar flex-v flex-limit is-size-5 has-text-weight-light">
    <!-- user pages -->
    <router-link to="/dashboard"><c-icon icon="fas-chart-area"/>Dashboard</router-link>
    <router-link v-if="user.subscriber" to="/devices"><c-icon icon="fas-hdd"/>Devices</router-link>
    <router-link v-if="user.subscriber" to="/keys"><c-icon icon="fas-key"/>Credentials</router-link>
    <a href="https://my.opswat.com" target="_blank" rel="noopener"><c-icon icon="fas-question-circle"/>Support</a>

    <!-- admin pages -->
    <template v-if="user && user.is_superuser">
      <hr>
      <!-- <div style="has-text-centered">Manage</div> -->
      <router-link  router-link to="/manage/diodes"><c-icon icon="fas-server"/>Manage Diodes</router-link>
      <router-link  router-link to="/manage/users"><c-icon icon="fas-user-shield"/>Manage Users</router-link>
    </template>
  </div>
</template>


<script>
import { get } from 'vuex-pathify';


export default {
  name: 'sidebar',
  computed: {
    user: get('user')
  },
};
</script>
